export default "__VITE_ASSET__BOeAgptW__"